import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LockTwoToneSvg from "@ant-design/icons-svg/es/asn/LockTwoTone";
import AntdIcon from "../components/AntdIcon";
var LockTwoTone = function LockTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LockTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LockTwoTone.displayName = 'LockTwoTone';
}
export default /*#__PURE__*/React.forwardRef(LockTwoTone);